import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  IssueTicketsRequest,
  Ticket,
  TicketsRequest,
  TicketsResponse,
} from './types'

export const changeStatusSubmit = createEvent<IssueTicketsRequest>()

export const ticketsListMounted = createEvent<TicketsRequest>()

export const setIsChangeStatusSuccess = createEvent<boolean>()

export const $isChangeStatusSuccess = restore(setIsChangeStatusSuccess, false)

export const getTickets = fx<TicketsRequest, TicketsResponse>({
  method: 'GET',
  url: `/promo/new_year_2026/tickets/issue`,
})

export const changeStatus = fx<void, void>({
  method: 'POST',
  url: `/promo/new_year_2026/tickets/issue`,
})

export const $tickets = restore<Ticket[]>(
  getTickets.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfTickets = restore(
  getTickets.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: changeStatusSubmit,
  fn: (id) => {
    return {
      url: `/promo/new_year_2026/tickets/issue`,
      body: {
        userID: id.userID,
      },
    }
  },
  target: changeStatus,
})

sample({
  // @ts-ignore
  clock: ticketsListMounted,
  fn: () => {},
  target: getTickets,
})

sample({
  clock: changeStatus.doneData,
  fn: () => {
    return true
  },
  target: [setIsChangeStatusSuccess, getTickets],
})
